export enum ActionType {
  LOGIN = "login",
  LOGOUT = "logout",
  SET_CURRENT_USER = "set_current_user",
  PUSH_MESSAGE = "push_message",
}
